import { Users, Code, Layout, Briefcase } from 'lucide-react';
import Alexey from '../../Assets/Images/Team/Alexey.png';
import Vlad from '../../Assets/Images/Team/Vlad.png';
import Nikita from '../../Assets/Images/Team/Nikita.png';
import Igor from '../../Assets/Images/Team/Igor.png';
import './Team.css';

const Team = () => {
  const teamMembers = [
    {
      img: Alexey,
      name: 'Алексей Викторович',
      role: 'Разработка',
      position: 'Генеральный директор АНО «ЦЦТ «Горизонт Сатурна» РС(Я)',
      icon: <Code className="role-icon" />
    },
    {
      img: Vlad,
      name: 'Владислав Александрович',
      role: 'Менеджмент',
      position: 'Главный операционный директор АНО «ЦЦТ «Горизонт Сатурна» РС(Я)',
      icon: <Briefcase className="role-icon" />
    },
    {
      img: Igor,
      name: 'Игорь Иванович',
      role: 'Разработка',
      position: 'Главный технический директор АНО «ЦЦТ «Горизонт Сатурна» РС(Я)',
      icon: <Code className="role-icon" />
    },
    {
      img: Nikita,
      name: 'Никита Сергеевич',
      role: 'Дизайн',
      position: 'DevOps инженер АНО «ЦЦТ «Горизонт Сатурна» РС(Я)',
      icon: <Layout className="role-icon" />
    }
  ];

  return (
    <section id="Team" className="team-section">
      <div className="team-header">
        <Users className="header-icon" size={40} />
        <h1>Наша команда</h1>
      </div>
      
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <div className="avatar-container">
              <img src={member.img} alt={member.name} className="team-avatar" />
              <div className="role-badge">
                {member.icon}
                <span>{member.role}</span>
              </div>
            </div>
            
            <div className="member-info">
              <h3>{member.name}</h3>
              <p className="position">{member.position}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Team;